
import CashTamerHttpClient from './CashTamerHttpClient';
import CashTamerApiBase from './CashTamerApiBase';
import TransactionDashboardResponseModel from '@/models/transactions/TransactionDashboardResponseModel';
import TransactionChangeDetailsRequestModel from '@/models/transactions/TransactionChangeDetailsRequestModel';
import TransactionLogResponseModel from '@/models/transactions/TransactionLogResponseModel';

export default class TransactionsApi extends CashTamerApiBase {

    public async getTransactionDashBoardAsync(bankAccountId: number, transactionId: number, jwt: string): Promise<TransactionDashboardResponseModel> {

        try {
            const httpClient = new CashTamerHttpClient();

            const url: string = 'member/bankaccounts/' + bankAccountId + '/transactions/' + transactionId;

            const httpResponse = await httpClient.secureGetAsync(url, jwt);

            const trans = new TransactionDashboardResponseModel();
            trans.authorizedOperations = httpResponse.data.authorizedOperations;
            trans.transactionId = httpResponse.data.transactionId;
            trans.bankAccountId = httpResponse.data.bankAccountId;
            trans.fundId = httpResponse.data.fundId;
            trans.fundName = httpResponse.data.fundName;
            trans.checkNumber = httpResponse.data.checkNumber;
            trans.debit = httpResponse.data.debit;
            trans.credit = httpResponse.data.credit;
            trans.transactionDate = httpResponse.data.transactionDate;
            trans.transactionDescription = httpResponse.data.transactionDescription;
            trans.createdBy = httpResponse.data.createdBy;
            trans.createdDateTimeUtc = httpResponse.data.createdDateTimeUtc;

            return trans;
        }
        catch (err) {
            return this.handleApiError(err);
        }
    }

    public async changeDetailsAsync(bankAccountId: number, transactionId: number, jwt: string, request: TransactionChangeDetailsRequestModel): Promise<void> {

        try {
            const httpClient = new CashTamerHttpClient();

            const url: string = 'member/bankaccounts/' + bankAccountId + '/transactions/' + transactionId + '/details';
            await httpClient.securePutAsync(url, request, jwt);
        }
        catch ( err ) {
            return this.handleApiError(err);
        }
    }

    public async getLogsAsync(bankAccountId: number, transactionId: number, jwt: string): Promise<TransactionLogResponseModel[]> {

        try {
            const httpClient = new CashTamerHttpClient();

            const url: string = 'member/bankaccounts/' + bankAccountId + '/transactions/' + transactionId + '/logs';
            const httpResponse = await httpClient.secureGetAsync(url, jwt);

            const values = new Array<TransactionLogResponseModel>();

            const len: number = httpResponse.data.length - 1;

            for ( let i = 0; i <= len; i++ ) {
                const value: TransactionLogResponseModel = new TransactionLogResponseModel();
                value.fieldName = httpResponse.data[i].fieldName;
                value.oldValue = httpResponse.data[i].oldValue;
                value.newValue = httpResponse.data[i].newValue;
                value.createdDateTimeUtc = httpResponse.data[i].createdDateTimeUtc;
                value.createdBy = httpResponse.data[i].createdBy;

                values.push(value);
            }

            return values;
        }
        catch (err) {
            return this.handleApiError(err);
        }
    }

}
